export default __webpack_public_path__ + "static/flat-image-e0b9a75f9c17efa169252acf11d9b5af.jpg";